import TachographGenerateButton from './TachographGenerateButton';
import { TachoTabs } from './TachographPopup';
import { useContext } from 'react';
import { ctxTachograph } from '@/contexts/TachographCtx';
import TachographDriverData from './TachographDriverData';
import { useTranslation } from 'react-i18next';
import TachographFileNameSelector from './TachographFileNameSelector';

export default function TachographDriverTab({ activeTab }: { activeTab: TachoTabs }) {
  const { t } = useTranslation();
  const tachographCtx = useContext(ctxTachograph);

  if (!tachographCtx) return null;

  return (
    <>
      <div id="target-tachograph-data">
        <h3 id="report-header-h3">{t('tachograph.driverSelector')}</h3>
        <TachographDriverData isListView={false} />
        {tachographCtx.selectedRowCardNumbers.length > 0 && (
          <div id="target-tachograph-data-menu">
            {/*
            <div style={{ opacity: '0' }}>
                Opacity 0 until e-mail sending not implemented  
              <h3 id="report-email-header">{t('tachograph.email.title')}</h3>
              <p className="report-comment">{t('tachograph.email.description')}</p>
              <TachographEmail />
              
            </div>*/}
            <div>
              <TachographFileNameSelector />
            </div>
            <div className="tachograph-button-conainer">
              <TachographGenerateButton activeTab={activeTab} />
              <p className="tachograph-comment tachograph-generate-comment">
                {t('tachograph.downloadButton.description')}
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
